import React, { useEffect, createRef } from 'react';
import Tooltip from 'Snippets/Tooltip';
import { Link } from 'reaouter';
import { HeadGear } from 'Templates';
import { isColorDark } from 'Common/Utils';
import { useLocal } from 'Source/App/Storage/Local';
import { localkey } from '../../local-config';
import {
	addHiddenEventListener,
	removeHiddenEventListener,
	keyHiddenEvent,
} from 'Common/Utils';

const PageNotFound = ({ home = '/' }) => {
	const expressionRef = createRef();
	const { getLocal } = useLocal(localkey.general)
	const { color } = getLocal() 
	useEffect(() => {
		const expression = expressionRef.current;
		const handler = () => {
			expression.classList[document[keyHiddenEvent] ? 'remove' : 'add'](
				'active'
			);
		};
		addHiddenEventListener(handler);
		return () => removeHiddenEventListener(handler);
	}, [expressionRef]);
	return (
		<div className='status-code'>
			<HeadGear>
                <HeadGear.Meta 
					title={`404 page not found | Mytabworks`}
					description="404 page not found"
					image='/images/icons/icon-512x512.png'
				/>
            </HeadGear>
			<div>
				<div className='status' data-color-changable={true}>404</div>
				<div ref={expressionRef} className='expression active' data-color-changable={true}>
					¯\_
					<Tooltip
						persistent
						offset={[50]}
						placement='left'
						variant={isColorDark(color) ? 'dark' : undefined}
						message={
							<>
								you'd better go <Link to={home} label='home' />
							</>
						}>
						<img src='/images/icons/icon-72x72.png' alt='beard-guy' />
					</Tooltip>
					_/¯
				</div>

				<h1>PAGE NOT FOUND</h1>
			</div>
		</div>
	);
};

export default PageNotFound